module.exports = __webpack_public_path__ + "img/whychooseus.0e1f1348.png";